import React from 'react';

const PaymentBreakdownSvg = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
            <path d="M12 3.5H19V21.5H5V3.5H12Z" stroke="#006CDD" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M14.5 4V7H9.5V4" stroke="#006CDD" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M9 10.5H12" stroke="#006CDD" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M9 13.5H14" stroke="#006CDD" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M9 16.5H15" stroke="#006CDD" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    );
};

export default PaymentBreakdownSvg;
